module.exports = __webpack_public_path__ + "static/handson-machine-learning-with-scikitlearn-keras-and-tensorflow-375cdcdb21af2b59d13c20c0137d5546.jpg";